import type React from "react";
import { ReactComponent as Svg } from "./assets/arrow-down-2.svg";
import * as styles from "./Icon.module.scss";

type FlucsDownProps = React.SVGProps<SVGSVGElement>;

export const FlucsDown = ({ className, ...props }: FlucsDownProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
